import TagManager from 'react-gtm-module';

export const registerEvent = (action) => {
    TagManager.dataLayer({
        dataLayer: {
            event: 'pok-activity',
            category: 'certificate',
            action: action,
        },
    });
};
